import { useNavigate } from 'react-router-dom'
import {
	ActiveJobSummary,
	ActiveJobType,
	useGetNotificationsQuery,
} from 'graphql/generated/scheme'
import { ActiveJobsIndicator } from 'pages/RepClubs/Contacts/components/active-jobs-indicator'
import { useAuth } from 'hooks/useAuth'
import { useStore } from 'hooks/useStore'

const LIMIT = 10

export default function TopBarActiveJobs() {
	const navigate = useNavigate()
	const { token } = useAuth()
	const { user } = useStore()

	// Read from the same cache that NotificationDropdown populates — no extra poll.
	const { data } = useGetNotificationsQuery({
		variables: { first: LIMIT },
		skip: !token || !user,
		fetchPolicy: 'cache-only',
	})

	const jobs = (data?.notification?.activeJobs ?? []) as ActiveJobSummary[]

	const handleOpen = (job: ActiveJobSummary) => {
		const params = new URLSearchParams()
		if (job.type === ActiveJobType.Import) params.set('importJobId', job.jobId)
		else if (job.type === ActiveJobType.Delete) params.set('deleteJobId', job.jobId)
		else if (job.type === ActiveJobType.Message) params.set('messageJobId', job.jobId)
		else if (job.type === ActiveJobType.Invite) {
			params.set('inviteJobId', job.jobId)
			if (job.eventId) params.set('inviteJobEventId', job.eventId)
		}
		navigate(`/manage/rep-clubs/contacts?${params.toString()}`)
	}

	return <ActiveJobsIndicator jobs={jobs} onOpen={handleOpen} />
}
